<template>

    <div class="page">
        <SidebarBody/>
        <TransactionsBody/>
    </div>
    
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import SidebarBody from "@/components/dashboard/SidebarBody.vue";
  import TransactionsBody from "@/components/dashboard/TransactionsBody.vue";
  
  export default defineComponent({
    name: "TransactionsView",
    components: {
      SidebarBody,
      TransactionsBody
    },
  });
  </script>
  